<template>
  <div class="hot-recom">
    <div class="htr-ti">Hot Books</div>
    <div class="ht-rbd">
      <div class="item" v-for="(item, index) of list" v-if="index < 4">
        <div class="img">
          <!-- <div class="img-tag1">{{ item.SOURCEOPENTYPE === "01" ? '借阅' : '畅读' }}</div> -->
          <a :href="$fun.getProductUrl(item.Id, item.ProductType)">
            <template v-if="item.Cover"><img :src="item.Cover" /></template>
            <template v-else><img src="/static/img/np-img.png" /></template>
          </a>
          <!-- <span class="img-tag">{{ item.ProductTypeText }}</span> -->
        </div>
        <div class="ri-info">
          <div class="name"><a :href="$fun.getProductUrl(item.Id, item.ProductType)">{{ item.Name }}</a></div>
          <div class="author">{{ item.Author }}</div>
          <div class="dec">{{ $fun.delHtmlTag(item.Introduction) }}</div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "HotRecom",
  data: function () {
    return {
      list: [],
    };
  },
  mounted: function () {
    this.$bti.GetBelongToColumnPage({ page: 1, rows: 20, wheres: { ColumnName: "热门推荐", OrgId: this.$fun.getMember().orgId, IsRandom: true } }).then((res) => {
      if (res.code != 1) {
        return;
      }
      this.list = res.data.rows;
    });
  },
  methods: {}
};
</script>

<style lang="css" scoped>
.hot-recom {
  padding: 30px;
}

.hot-recom .htr-ti {
  font-size: 18px;
  font-weight: bold;
  margin-bottom: 20px;
}

.hot-recom .ht-rbd .item:after {
  display: block;
  overflow: hidden;
  clear: both;
  height: 0;
  visibility: hidden;
  content: "";
}

.hot-recom .ht-rbd .item {
  margin: 30px 0px;
}

.hot-recom .ht-rbd .item .img {
  float: left;
  width: 115px;
  height: 151px;
  box-shadow: 0px 0px 5px #ccc;
  -moz-box-shadow: 0px 0px 5px #ccc;
  -o-box-shadow: 0px 0px 5px #ccc;
  -webkit-box-shadow: 0px 0px 5px #ccc;
  cursor: pointer;
}

.hot-recom .ht-rbd .item .img a {
  position: relative;
  display: block;
  cursor: pointer;
}

.hot-recom .ht-rbd .item .img img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.hot-recom .ht-rbd .item .ri-info {
  float: left;
  width: calc(100% - 135px);
  margin-left: 20px;
}

.hot-recom .ht-rbd .item .ri-info a {
  color: #333;
  cursor: pointer;
}

.hot-recom .ht-rbd .item .name {
  font-size: 16px;
  font-weight: bold;
  margin-bottom: 10px;
}

.hot-recom .ht-rbd .item .author {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  margin-bottom: 5px;
}

.hot-recom .ht-rbd .item .dec {
  margin-top: 10px;
  line-height: 1.8;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  width: 100%;
}

.book-list-con {
  padding-top: 15px;
  padding-left: 0px;
  padding-right: 0px;
}

.item .img {
  position: relative;
}

.item .img .img-tag {
  position: absolute;
  right: 0px;
  bottom: -2px;
  background: #e98e07;
  color: #fff;
  padding: 3px 5px;
}

.item .img .img-tag1 {
  position: absolute;
  top: 0;
  right: 0;
  width: 48px;
  height: 48px;
  background: linear-gradient(-135deg, #409EFF, #409EFF 50%, transparent 50%, transparent 100%);
  color: #fff;
  padding-left: 19px;
  z-index: 1
}
</style>



// WEBPACK FOOTER //
// src/common/other/HotRecom.vue